import { render, staticRenderFns } from "./SetupTooltip.vue?vue&type=template&id=1fa028d0"
import script from "./SetupTooltip.vue?vue&type=script&lang=js"
export * from "./SetupTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports